import { addToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { LiveEventLoadByGroupIdAction } from '../../domains/liveEventLoadByGroupId/actions.types';

import type { LiveEventLoadByGroupId } from './types';

export type { LiveEventLoadByGroupIdAction };

const initialState: LiveEventLoadByGroupId = {};

const reducer: Reducer<LiveEventLoadByGroupId, LiveEventLoadByGroupIdAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'LIVE_EVENT.LOAD_BY_GROUP_ID_PENDING':
      return addToRecord(state, action.payload.groupId, 'pending');
    case 'LIVE_EVENT.LOAD_BY_GROUP_ID_FULFILLED':
      return addToRecord(state, action.payload.groupId, 'fulfilled');
    case 'LIVE_EVENT.LOAD_BY_GROUP_ID_REJECTED':
      return addToRecord(state, action.payload.groupId, 'rejected');
    default:
      return state;
  }
};

export default reducer;
